<template>
  <div class="product-add">
    <div class="common-form">基本信息</div>

      <el-form-item label="选择用户">
        <el-row>
          <el-button @click="addClick" icon="el-icon-plus">选择会员</el-button>
          <div v-if="form.user_id!=''" class="img">
            <img :src="user_info.avatarUrl" width="100" height="100" />
          </div>
          <div>
            <el-link :underline="false" disabled>选择后不可更改</el-link>
          </div>
        </el-row>
      </el-form-item>

      <el-form-item label="头像" prop="avatar_image" >
        <el-row>
          <el-button icon="el-icon-picture-outline" @click="openUpload({'type':'avatar'})">选择图片</el-button>
            <img :src="form.avatar_image" width="100" height="100" />
        </el-row>
      </el-form-item>


      <el-form-item label="所属公司">
        <el-select v-model="form.supply_id" filterable placeholder="请选择">
          <el-option :value="0" :label="'无归属'"></el-option>
          <el-option v-for="item in supplyList" :key="item.supply_id" :label="item.name" :value="item.supply_id"></el-option>
        </el-select>
        <div>
          <el-link :underline="false" disabled>选择后不可更改</el-link>
        </div>
      </el-form-item>

      <el-form-item label="其他公司">
        <el-input type='textarea' v-model="form.more_supply"></el-input>
        <div class="gray">多个公司用;隔开，如'xxxx公司;xxxx公司'</div>
      </el-form-item>

      <el-form-item label="排序" prop="displayorder" >
        <el-input class="max-w460" type='number' v-model="form.displayorder" placeholder="请输入数字"></el-input>
        <div class="gray">数字越小排序越靠前</div>
      </el-form-item>

      <el-form-item label="姓名" prop="name" :rules="[{required: true,message: '请输入姓名'}]">
        <el-input class="max-w460" v-model="form.name" placeholder="请输入姓名"></el-input>
      </el-form-item>

      <el-form-item label="职位" prop="occupation">
        <el-input class="max-w460" v-model="form.occupation" placeholder="请输入职位"></el-input>
      </el-form-item>

      <el-form-item label="手机号" prop="mobile" :rules="[{required: true,message: '请输入手机号'}]">
        <el-input class="max-w460" v-model="form.mobile" placeholder="请输入手机号"></el-input>
      </el-form-item>

      <el-form-item label="微信" prop="wechat" >
        <el-input class="max-w460" v-model="form.wechat" placeholder="请输入微信号"></el-input>
      </el-form-item>

      <el-form-item label="邮箱" prop="email" >
        <el-input class="max-w460" v-model="form.email" placeholder="请输入邮箱"></el-input>
      </el-form-item>

      <el-form-item label="类型" prop="type" >
        <el-select v-model="form.type" filterable placeholder="请选择">
          <el-option v-for="(item,index) in typelist" :key="index" :label="item.name" :value="item.value"></el-option>
        </el-select>
      </el-form-item>

      <el-form-item label="所属行业分类：" prop="category_id">
      <el-select v-model="form.category_id">
        <template v-for="cat in category">
          <el-option :value="cat.card_category_id" :key="cat.card_category_id" :label="cat.name"></el-option>
          <template v-if="cat.child !== undefined" v-for="two in cat.child">
            <el-option :value="two.card_category_id" :key="two.card_category_id" :label="two.name" style="padding-left: 30px;"></el-option>
            <template v-if="two.child !== undefined" v-for="three in two.child">
              <el-option :value="three.card_category_id" :key="three.card_category_id" :label="three.name" style="padding-left: 60px;"></el-option>
            </template>
          </template>
        </template>
      </el-select>
    </el-form-item>


    <el-form-item label="所在区域">
        <el-select v-model="form.province_id" placeholder="省" @change="initCity">
          <el-option :label="item.name" :value="item.id" v-for="(item,index) in areaList" :key='index'></el-option>
        </el-select>
        <el-select v-if="form.province_id!=''" v-model="form.city_id" placeholder="市" @change="initRegion">
          <el-option :label="item1.name" :value="item1.id" v-for="(item1,index1) in areaList[form.province_id]['city']"
            :key='index1'></el-option>
        </el-select>
        <el-select v-if="form.city_id!=''" v-model="form.region_id" placeholder="区">
          <el-option :label="item2.name" :value="item2.id" v-for="(item2,index2) in areaList[form.province_id]['city'][form.city_id]['region']"
            :key='index2'></el-option>
        </el-select>

      </el-form-item>

       <el-form-item label="个人介绍">
        <el-input type="textarea" v-model="form.introduce" placeholder="请输入个人介绍" class="max-w460"></el-input>
      </el-form-item>

      <el-form-item label="详情图片：" prop="images">
      <div class="draggable-list">
        <draggable class="wrapper" v-model="form.images">
          <transition-group>
            <div class="item" v-for="item in form.images" :key="item.file_path">
              <img v-img-url="item.file_path" />
              <a href="javascript:void(0);" class="delete-btn" @click.stop="deleteImg(item)"><i class="el-icon-close"></i></a>
            </div>
          </transition-group>
        </draggable>
        <div class="item img-select" @click="openProductUpload"><i class="el-icon-plus"></i></div>
      </div>
      </el-form-item>

      <el-form-item label="视频封面图" prop="poster" >
        <el-row>
          <el-button icon="el-icon-picture-outline" @click="openUpload({'type':'poster'})">选择图片</el-button>
          <div v-if="form.poster_id!=''" class="img">
            <img :src="form.poster" width="100" height="100" />
          </div>
        </el-row>
      </el-form-item>

      <el-form-item label="视频" prop="video" >
 
          <el-input type="text"  readonly v-model="form.video"  placeholder="请选择视频" class="max-w460">
            <template slot="append">
             <el-button icon="el-icon-picture-outline" @click="openVideoUpload">选择视频</el-button>
            </template>
          </el-input>
      </el-form-item>


      <!--标签选择-->
      <el-form-item size="small" label="选择标签">
        <el-button icon="el-icon-plus" @click="changeLabel(form.labelList)">选择标签</el-button>
        <div class="pb50">
          <el-tag  v-for="(tag,index) in form.labelList" :key="tag.name" closable :disable-transitions="false" @close="deleteClick(index)" :type="tag.type"> {{tag.name}} </el-tag>
        </div>
      </el-form-item>
      
      <el-form-item label="有效期">
        <el-date-picker
          v-model="form.active_time"
          type="datetimerange"
          align="right"
          unlink-panels
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          format="yyyy-MM-dd HH:mm"
          value-format="yyyy-MM-dd HH:mm"
          :picker-options="pickerOptions"
          ></el-date-picker>
      </el-form-item>

      <el-form-item label="状态">
        <el-radio-group v-model="form.status">
          <el-radio :label="1">启用</el-radio>
          <el-radio :label="0">禁用</el-radio>
        </el-radio-group>
      </el-form-item>
     

    <!--添加-->
    <GetUser :is_open="open_add" @close="closeDialogFunc"></GetUser>

    <!--添加-->
    <Upload v-if="isProductUpload" :config="{ total: 9 }" :isupload="isProductUpload" @returnImgs="returnProductImgsFunc">上传图片</Upload>

    <!--上传图片组件-->
    <Upload v-if="isupload" :isupload="isupload" type="image" @returnImgs="returnImgsFunc">上传封面图片</Upload>

    <!--上传头像组件-->
    <Upload v-if="avatarUpload" :isupload="isupload" type="image" @returnImgs="returnAvartarFunc">上传头像图片</Upload>

    <!--上传视频组件-->
    <Upload v-if="isVideoUpload" :isupload="isVideoUpload" type="video" @returnImgs="returnVideosFunc">上传视频</Upload>

    <Label :islabel="islabel" labelType="card" :excludeLabelIds="excludeLabelIds" :islist="true" @closeDialog="closeDialogLabelFunc"></Label>
  </div>
</template>

<script>
  import cardApi from '@/api/card.js';
  import draggable from 'vuedraggable';
  import Upload from '@/components/file/Upload';
  import GetUser from '@/components/user/GetUser.vue';
  import Label from '@/components/label/Label.vue';
  import { mergeTable } from '@/utils/table.js';
  // import select_region from '@/utils/select.region.js';
  import select_region from '@/utils/select.district.js';
  export default {
    components: {
      /*编辑组件*/
      GetUser,
      Upload,
      draggable,
      Label
    },
    data() {
      return {
        typelist:[],
        isProductUpload: false,
        isVideoUpload:false,
        avatarUpload:false,
        isupload:false,
        /*是否打开添加弹窗*/
        open_add: false,
        supplyList: [],
        user_info:{},
        /* 是否显示标签 */
        islabel:false,
        /*标签去重*/
        excludeLabelIds: [],
        /*如果没有后面的-8.64e7就是不可以选择今天的*/
        pickerOptions: {
          disabledDate(time) {
            return time.getTime() < Date.now() - 8.64e7;
          }
        },
        category:[],
         /*省市区*/
        areaList: select_region,
      };
    },
    props: ['form'],
    created() {
      /*获取列表*/
      console.log(select_region,this.areaList);
      this.user_info = this.form.user
      this.getTableList();
      this.getCategoryList();
    },

    methods: {

      /*获取供应商列表*/
      getTableList() {
        let self = this;
        cardApi.getSupplyList('', true)
          .then(res => {
            self.supplyList = res.data.list;
            self.typelist = res.data.typelist;
          })
          .catch(error => {

          });
      },

      getCategoryList() {
         let self = this;
        cardApi.getCategoryList('', true)
          .then(res => {
            self.category = res.data.category;
          })
          .catch(error => {

          });
      },


      /*打开弹出层*/
      addClick() {
        this.open_add = true;
      },

      /*关闭获取用户弹窗*/
      closeDialogFunc(e) {
        if (e.type != 'error') {
          this.user_info = e.params[0];
          this.form.user_id = e.params[0].user_id;
        }
        this.open_add = false;
      },
      
      /*打开上传图片*/
      openProductUpload: function() {
        this.isProductUpload = true;
      },

      /*上传商品图片*/
      returnProductImgsFunc(e) {
        if (e != null) {
          let imgs = this.form.images.concat(e);
          this.$set(this.form, 'images', imgs);
        }
        this.isProductUpload = false;
      },

      /*删除商品图片*/
      deleteImg(e) {
        console.log(this.form);
        for (var i = 0; i < this.form.images.length; i++) {
          if (e.file_id == this.form.images[i].file_id) {
            this.form.images.splice(i, 1);
          }
        }
      },
      /*上传封面图*/
      openUpload(e) {
        if(e.type=='poster'){
          this.isupload = true;
        }else{
          this.avatarUpload = true;
        }
        
      },

       /*获取图片*/
      returnImgsFunc(e) {
        if (e != null && e.length > 0) {
          this.form.poster = e[0].file_path;
          this.form.poster_id = e[0].file_id;
        }
        this.isupload = false;
      },

      /*获取图片*/
      returnAvartarFunc(e) {
        if (e != null && e.length > 0) {
          this.form.avatar_image = e[0].file_path;
        }
        this.avatarUpload = false;
      },

      /* 打开视频 */

      openVideoUpload(){

        this.isVideoUpload = true;
      },

      /* 获取视频 */
      returnVideosFunc(e) {
        console.log(e);
        if (e != null && e.length > 0) {
          this.form.video = e[0].file_path;
        }
        this.isVideoUpload = false;
      },

      /* 选择标签 */
      changeLabel(list){
        let arr = [];
  
        list.forEach(item => {
          arr.push(item.kmd_label_id);
        });
        
        
        this.excludeLabelIds = arr;
        this.islabel = true;
      },

      /* 删除标签 */

      deleteClick(e) {
        let curItem=this.form.labelList[e];
        for (let i = 0; i < this.form.labelList.length; i++) {
            let item = this.form.labelList[i];
            if (curItem.kmd_label_id == item.kmd_label_id) {
              this.form.labelList.splice(i, 1);
            }
          }
      },

      /* 关闭标签窗口 */

      closeDialogLabelFunc(e) {
        let self = this;
        self.islabel = false;
        if (e.type == 'success') {
          let arr = [];
          for (let i = 0; i < e.params.length; i++) {
            let item = e.params[i];
            let obj = {
              name: item.name,
              kmd_label_id: item.kmd_label_id
            };
            arr.push(obj);
          }
          self.form.labelList = self.form.labelList.concat(arr);
          self.form.labelList = mergeTable(this.form.labelList);
        }
      },

      /*初始化城市id*/
      initCity() {
        this.form.city_id = ''
      },

      /*初始化区id*/
      initRegion() {
        this.form.region_id = ''
      },


    }

  };
</script>

<style lang="scss" scoped>
  .basic-setting-content {}

  .product-add {
    padding-bottom: 50px;
  }

  .img {
    margin-top: 10px;
  }

  .edit_container {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  line-height: 20px;
  color: #2c3e50;
}

.ql-editor {
  height: 400px;
}

.draggable-list {
  display: flex;
  justify-content: flex-start;
  flex-wrap: wrap;
}
.draggable-list .wrapper > span {
  display: flex;
  justify-content: flex-start;
  flex-wrap: wrap;
}

.draggable-list .item {
  position: relative;
  width: 110px;
  height: 110px;
  margin-top: 10px;
  margin-right: 10px;
  border-radius: 8px;
  overflow: hidden;
  border: 1px solid #dddddd;
}

.draggable-list .delete-btn {
  position: absolute;
  top: 0;
  right: 0;
  width: 16px;
  height: 16px;
  background: red;
  line-height: 16px;
  font-size: 16px;
  color: #ffffff;
  display: none;
}

.draggable-list .item:hover .delete-btn {
  display: block;
}

.draggable-list .item img {
  position: absolute;
  top: 50%;
  left: 50%;
  -webkit-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
  max-height: 100%;
  max-width: 100%;
}

.draggable-list .img-select {
  display: flex;
  justify-content: center;
  align-items: center;
  border: 1px dashed #dddddd;
  font-size: 30px;
}

.draggable-list .img-select i {
  color: #409eff;
}
</style>



// WEBPACK FOOTER //
// src/views/plus/card/cardlist/part/Basic.vue